import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { rbacApi } from '../../Api/superadminApicall';

// Async thunks
export const fetchRoles = createAsyncThunk(
  'roles/fetchRoles',
  async ({ page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
      const response = await rbacApi.roles.list(page, limit, search);


      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch roles');
    }
  }
);

export const createRole = createAsyncThunk(
  'roles/createRole',
  async (roleData, { rejectWithValue }) => {
    try {
      const response = await rbacApi.roles.create(roleData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create role');
    }
  }
);

export const updateRole = createAsyncThunk(
  'roles/updateRole',
  async ({ roleId, roleData }, { rejectWithValue }) => {
    try {
      const response = await rbacApi.roles.update(roleId, roleData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update role');
    }
  }
);

// const initialState = {

const RolesSlice = createSlice({
    name: "RolesSlice",
    initialState: {
        Roledta: [],
        Roleadd: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchRoles.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRoles.fulfilled, (state, action) => {
                state.loading = false;
                state.Roledta = action.payload;
            })
            .addCase(fetchRoles.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createRole.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createRole.fulfilled, (state, action) => {
                state.loading = false;
                state.Roleadd = action.payload;
            })
            .addCase(createRole.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateRole.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateRole.fulfilled, (state, action) => {
                state.loading = false;
                // Optionally update chatMessages if API returns updated messages
                // Otherwise, we'll refetch messages after sending
            })
            .addCase(updateRole.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});
//   roles: [],
//   pagination: {
//     currentPage: 1,
//     totalPages: 0,
//     totalItems: 0,
//     itemsPerPage: 10
//   },
//   loading: false,
//   error: null,
//   success: null
// };

// const rolesSlice = createSlice({
//   name: 'roles',
//   initialState,
//   reducers: {
//     clearError: (state) => {
//       state.error = null;
//     },
//     clearSuccess: (state) => {
//       state.success = null;
//     },
//     resetState: (state) => {
//       state.roles = [];
//       state.pagination = initialState.pagination;
//       state.loading = false;
//       state.error = null;
//       state.success = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       // Fetch roles
//       .addCase(fetchRoles.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchRoles.fulfilled, (state, action) => {
//         state.loading = false;
//         state.roles = action.payload.data?.roles || [];
//         state.pagination = {
//           currentPage: action.payload.data?.pagination?.currentPage || 1,
//           totalPages: action.payload.data?.pagination?.totalPages || 0,
//           totalItems: action.payload.data?.pagination?.totalItems || 0,
//           itemsPerPage: action.payload.data?.pagination?.itemsPerPage || 10
//         };
//         state.success = 'Roles fetched successfully';
//       })
//       .addCase(fetchRoles.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
      
//       // Create role
//       .addCase(createRole.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(createRole.fulfilled, (state, action) => {
//         state.loading = false;
//         state.roles.unshift(action.payload.data);
//         state.success = 'Role created successfully';
//       })
//       .addCase(createRole.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
      
//       // Update role
//       .addCase(updateRole.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateRole.fulfilled, (state, action) => {
//         state.loading = false;
//         const index = state.roles.findIndex(
//           role => role.id === action.payload.data.id
//         );
//         if (index !== -1) {
//           state.roles[index] = action.payload.data;
//         }
//         state.success = 'Role updated successfully';
//       })
//       .addCase(updateRole.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   }
// });

export const { clearError, clearSuccess, resetState } = RolesSlice.actions;
export default RolesSlice.reducer;